import api from "api";
import BlockHeader from "component/BlockHeader/BlockHeader";
import PaginationWrapper from "component/Pagination";
import {InitiativeList} from "component/InitiativeList";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { createBrowserHistory, parsePath } from "history";
import { useLocation, useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import stateMap from "store/stateMap";
import update from 'immutability-helper';
import {ReactComponent as SVGArrowUp} from '../../../../../assets/arrow-up.svg';
import "./../../../Browse/style.scss";
import Sidebar from "component/Sidebar";
import _ from "lodash";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import Breadcrumb from "component/Breadcrumb";
import { PageCredential } from "component/PageCredential";

export default connect(stateMap)((props) => {


    let location                                = useLocation();
    let history                                 = createBrowserHistory();
    
    const [initiatives, setInitiatives]         = useState(false);
    const [countInitiative, setCountInitiative] = useState(false);
    const [dataLoading, setDataLoading]         = useState(false) ;
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('page') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 9
    });


    const changeParams = (e) => {
        e.preventDefault();

        if(dataLoading)
        {
            return;
        }

        let [toUpdateFilter, updatedValue] = e.currentTarget.name.split(':');

        setParameter(
            update(parameter, { $apply : function(params){

                if(params[toUpdateFilter] == updatedValue)
                {
                    params[toUpdateFilter] = '';
                }
                else
                {
                    params[toUpdateFilter] = updatedValue;
                }
    
                params.paged = 1;
    
                return _.assign({}, params);
    
            }})
        );
    }

    const loadInitiative = () => {

        if(dataLoading)
        {
            return;
        }

        let processedParameter = update(parameter, {
            $apply : prm => {
                if(prm.event_type_id)
                {
                    prm.event_type_id = [prm.event_type_id];
                }
                return prm;
            }
        })

        var DataToLoad = [
            api('/Initiative', 'get', _.assign({type : 'talent'}, parameter))
        ];

        if(parameter.paged === 1)
        {
            DataToLoad.push(
                api('/Initiative', 'get', _.assign({get_total : 1, type : 'talent'}, parameter))
            );
        }

        setDataLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setDataLoading(false);

                setInitiatives(response[0].initiative);

                history.replace(
                    { search: `?${createSearchParams(parameter)}`}
                );

                if(parameter.paged === 1)
                {
                    setCountInitiative( parseInt(response[1].initiative) );
                }

            })
            .catch((error) => {
                setDataLoading(false);
                
            })
    }
    
    useEffect(loadInitiative, [props.auth.user, parameter]);

    return(
        <>
            <Header/>
            <PageCredential title={'Archive of Talent Initiatives'}/>
            <div className="container relative">
                <Breadcrumb
                    items={[
                        ['/', 'Crowdbees']
                        ,['/talent/', 'Talent Team']
                        ,['Browse']
                    ]}
                />
                <div className="initiatives-list">
                    {
                        initiatives === false ? <span className="skeleton"></span>:
                        (
                            <Fragment>
                                {
                                    dataLoading ? <div><span className="skeleton"></span></div> :
                                    <>
                                        { 
                                            <BlockHeader title="Talent Team" desc={"About "+ countInitiative +" initiatives"}/>
                                        }
                                        <InitiativeList initiatives={initiatives}/>
                                        <PaginationWrapper
                                            className="mt-4"
                                            activePage={parameter.paged}
                                            itemsCountPerPage={parameter.posts_per_page}
                                            totalItemsCount={countInitiative}
                                            pageRangeDisplayed={5}
                                            onChange={(pagenumber) => {
                                                setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                            }}
                                        />
                                    </>
                                }
                            </Fragment>
                        )
                    }
                </div>
                
            </div>
            <Footer/>
        </>
    )
});